import { ClientBillingAggregationResult } from '../api/models';

export class AggregationResultStatus {

    public static New: ClientBillingAggregationResult["status"] = 'New';
    public static Rerun: ClientBillingAggregationResult["status"] = 'Rerun';
    public static Completed: ClientBillingAggregationResult["status"] = 'Completed';
    public static Invoved: ClientBillingAggregationResult["status"] = 'Invoiced';
    public static Sent: ClientBillingAggregationResult["status"] = 'Sent';
}